/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Caption_Lock_TitleInputs */

const en_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock CC or AD to Video`)
};

const fr_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrouiller CC ou AD sur la Video`)
};

const de_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CC oder AD an Video sperren`)
};

const it_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocca CC o AD sul video`)
};

const ru_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привязать субтитры или рекламу к видео`)
};

const es_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear CC o AD en el vídeo`)
};

const zh_cn2_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`锁定 CC 或 AD 到视频`)
};

const ja_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CC または AD をビデオにロックする`)
};

const hi_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो पर CC या AD को लॉक करें`)
};

const pt_pt2_player_caption_lock_title = /** @type {(inputs: Player_Caption_Lock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear legendas ou anúncios no vídeo`)
};

/**
* | output |
* | --- |
* | "Lock CC or AD to Video" |
*
* @param {Player_Caption_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_caption_lock_title = /** @type {((inputs?: Player_Caption_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Caption_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_caption_lock_title(inputs)
	if (locale === "de") return de_player_caption_lock_title(inputs)
	if (locale === "it") return it_player_caption_lock_title(inputs)
	if (locale === "ru") return ru_player_caption_lock_title(inputs)
	if (locale === "es") return es_player_caption_lock_title(inputs)
	if (locale === "zh-CN") return zh_cn2_player_caption_lock_title(inputs)
	if (locale === "ja") return ja_player_caption_lock_title(inputs)
	if (locale === "hi") return hi_player_caption_lock_title(inputs)
	if (locale === "pt-PT") return pt_pt2_player_caption_lock_title(inputs)
	return en_player_caption_lock_title(inputs)
});